import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useLanguage } from "../../LanguageProvider";
import Header from "../Reutilizables/Header/Header";
import Footer from "../Reutilizables/Footer/Footer";
import Hero from "../Reutilizables/Hero/Hero";
import "./Location.css";

function Location() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const { t } = useTranslation();
  const { language } = useLanguage();

  return (
    <div className="app-shell location-page">
      <Header />
      <main className="page-main">
        <Hero compact className="location-hero" />
        <section className="location-section">
          <div className="lh-container">
            <h1 className="section-title">{language === "en" ? "LOCATION" : "UBICACIÓN"}</h1>
            <p className="section-subtitle mb-4">
              {language === "en" ? "Professional language services where you need them." : "Servicios profesionales de idiomas donde los necesites."}
            </p>
            <div className="location-grid">
                <article className="location-card">
                <i className="bi bi-whatsapp" aria-hidden="true" />
                <h2>SOUTH FLORIDA</h2>
                <span />
                <a href="https://wa.me/17868198806" target="_blank" rel="noopener noreferrer">
                  {language === "en" ? "Chat on WhatsApp" : "Chatear por WhatsApp"}
                </a>
              </article>
              <article className="location-card">
                <i className="bi bi-whatsapp" aria-hidden="true" />
                <h2>LAS VEGAS</h2>
                <span />
                  <a href="https://wa.me/17752535836" target="_blank" rel="noopener noreferrer">
                  {language === "en" ? "Chat on WhatsApp" : "Chatear por WhatsApp"}
                  </a>
              </article>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}

export default Location;
